(function () {
  'use strict';

  angular.module('app').component('packageContentPage', packageContentDetailCtrl());

  function packageContentDetailCtrl() {
    return {
      bindings: {},
      controller: PackageContentDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/package-contents/package-content-page.component.html',
    };
  }

  PackageContentDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'LanguageService',
    'PackageContentService',

    // Angular downgraded service
    'sessionService',
  ];

  function PackageContentDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    LanguageService,
    PackageContentService,

    // Angular downgraded service
    sessionService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_package_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.packageId = $routeParams.packageId; // optional from modal
    vm.websiteId = $routeParams.WSID;

    // Methods
    vm.onPackageContentSaved = onPackageContentSaved;
    vm.onPackageContentCanceled = onPackageContentCanceled;

    // Initializers
    getLanguages();
    // getPackageContent();

    function getLanguages() {
      const websiteStored = sessionService
        .getSelectedAccountCompany()
        .websites.find((x) => x.id === vm.websiteId);

      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        const languages = data.items;

        vm.defaultLanguage = languages.find((x) => x.id === websiteStored.language_id).lang; // use .lang
        vm.additionalLanguages = languages
          .filter((x) => websiteStored.language_ids.includes(x.id))
          .filter((y) => y.id !== websiteStored.language_id);

        // vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        // vm.additionalLanguages = languages.filter((language) => !language.is_default);

        getPackageContent();
      });
    }

    function getPackageContent() {
      if (itemId) {
        //Edit
        vm.loadingItem = true;
        PackageContentService.getPackageContent(itemId, vm.defaultLanguage).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onPackageContentSaved(item) {
      $location.path(`/package_contents/${item.id}`).search({ WSID: vm.websiteId });
    }

    function onPackageContentCanceled() {
      $location.path(`/package_contents`).search({ WSID: vm.websiteId });
    }
  }
})();
